export default __webpack_public_path__ + "static/media/star.300913bf.svg";